import React, { useEffect, useState } from 'react';
import CreateWidgets from './CreateWidgets';
import { websiteRegex } from '../../../../function/Regex';
import { generateWidgets, getWidgetsInfo, updateWidgets } from '../../../../api/AccountSetup';
import ToastNotification from '../../../../common/ToastNotification';
import { useNavigate } from 'react-router-dom';
import getCustomMenuEffect from '../../../../hooks/Menu';
interface WidgesProps {
  isSettings?: boolean | undefined;
}
const Widgets = (props: WidgesProps) => {
  const { isSettings } = props;
  const companyUuid = sessionStorage.getItem('companyUuid');
  const businessType = sessionStorage.getItem('businessType');
  const navigate = useNavigate();
  const { menu } = getCustomMenuEffect(companyUuid ? companyUuid : '');

  const [isSubmit, setIsSubmit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [state, setState] = useState({
    website: '',
    websiteError: '',
    chatbotName: '',
    nameErr: '',
    listOfThemes: [
      '#3572EF',
      '#98ABEE',
      '#7776B3',
      '#1D24CA',
      '#9290C3',
      '#73EC8B',
      '#FF7F3E',
      '#6A1E55',
      '#E5D9F2'
    ],
    selectedTheme: '#D10707FF',
    storedTheme: '#D10707FF'
  });
  const [widgetUUID, setWidgetUUID] = useState('');

  const handleState = (field: string, value: string) => {
    setState((prevState) => {
      let newState: any = { ...prevState };

      if (field === 'website') {
        newState[field] = value;
        newState.websiteError = !websiteRegex.test(value) ? 'Please enter valid URL' : '';
      } else if (field === 'chatbotName') {
        newState[field] = value;
        newState.nameErr = value ? '' : 'Please enter name';
      } else {
        newState[field] = value;
      }

      return newState;
    });
  };

  const handleCreateOrUpdateWidgets = async (e: any) => {
    try {
      if (
        state.chatbotName &&
        (businessType !== 'Retail' ? state.website && !state.websiteError : true)
      ) {
        setIsDisabled(true);
        let payload: any = {
          theme: state.selectedTheme,
          name: state.chatbotName,
          website: state.website
        };
        if (widgetUUID) {
          payload = { ...payload, uuid: widgetUUID };
        }
        const res = widgetUUID
          ? await updateWidgets(payload, companyUuid ? companyUuid : '')
          : await generateWidgets(payload, companyUuid ? companyUuid : '');
        if (res.message === 'Created' || res.message === 'Updated') {
          ToastNotification({
            message: res.message,
            type: 'success'
          });
          setIsDisabled(false);
          if (businessType === 'Retail' && !isSettings) {
            navigate('/account-setup/integration');
          }
          if (businessType !== 'Retail') {
            setIsSubmit(true);
          }
        } else {
          ToastNotification({
            message: res.message,
            type: 'error'
          });
          setIsDisabled(false);
        }
      } else {
        handleState('nameErr', state.chatbotName ? state.nameErr : 'Please enter name');
        handleState('websiteError', state.website ? state.websiteError : 'Please enter URL');
      }
    } catch {
      setIsDisabled(false);
    }
  };

  const fetchWidgetInfo = async () => {
    try {
      const res = await getWidgetsInfo(companyUuid ? companyUuid : '');
      if (res.message === 'Successful') {
        if (res.payload.uuid !== null) {
          setWidgetUUID(res.payload.uuid);
          setState({
            ...state,
            website: res?.payload?.widges?.website,
            selectedTheme: res?.payload?.widges?.colorTheme,
            chatbotName: res?.payload?.widges?.name,
            storedTheme: res?.payload?.widges?.colorTheme
          });
        }
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchWidgetInfo();
  }, []);

  return (
    <CreateWidgets
      state={state}
      isSubmit={isSubmit}
      isDisabled={isDisabled}
      setIsSubmit={setIsSubmit}
      handleState={handleState}
      handleCreateOrUpdateWidgets={handleCreateOrUpdateWidgets}
      isSettings={isSettings}
      menu={menu}
    />
  );
};

export default Widgets;
